module.exports = __webpack_public_path__ + "static/media/105.5cbd05de.jpg";